<!-- 公众号与支付 -->
<template>
    <div class="container">
        <!-- 公众号设置 -->
        <div class="content section-wechat">
            <div class="section-header">
                <Icon type="ios-chatboxes-outline" size="20" />
                <span>公众号设置</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="150">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="强制关注公众号：">
                            <i-switch v-model="formData.need_follow_wechat" size="large" true-color="var(--primary-color)" :true-value="1" :false-value="0">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                            <Tooltip max-width="300" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>强制关注公众号功能只针对开启后生成的溯源码有效</p>
                                    </div>
                                </Tooltip>
                        </FormItem>
                    </Col>
                    <template v-if="formData.need_follow_wechat">
                        <Col span="8">
                            <FormItem label="公众号ID：">
                                <Input class="w200" type="text" v-model="formData.gh_id" placeholder="请输入公众号ID"></Input>
                                <Tooltip max-width="300" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>请填写您的微信公众号的公众号ID。要使用强制用户关注公众号功能必须填写此项</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                    </template>
                </Row>
                <Row :gutter="24"> 
                    
                    <Col span="8">
                        <FormItem label="启用公众号：">
                            <i-switch v-model="formData.is_wx" size="large" true-color="var(--primary-color)" :true-value="1" :false-value="0">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Col>
                    <template v-if="formData.is_wx">
                        <Col span="8">
                            <FormItem label="AppSecret：">
                                <Input class="w200" type="text" v-model="formData.app_secret" placeholder="请输入AppSecret"></Input>
                                <Tooltip max-width="300" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>请填写您的微信认证服务号AppSecret，并在公众平台中设置oAuth授权域名为当前系统域名</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="ApplD：">
                                <Input class="w200" type="text" v-model="formData.app_id" placeholder="请输入ApplD"></Input>
                                <Tooltip max-width="300" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>请填写您的微信认证服务号AppID，设置好以后请不要随意更换，否则将导致用户无法正常使用</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="biz：">
                                <Input class="w200" type="text" v-model="formData.biz" placeholder="请输入biz"></Input>
                                <Tooltip max-width="300" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>随便找一篇该公众号的文章，在浏览器打开并查看源码，搜索 var biz，复制引号内的值</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="公众号二维码：">
                                <div class="image-div">
                                    <div class="form_upload mr12" @click="openModal(1)">
                                        <Icon type="ios-add" size="40" color="#AEAEB3"/>
                                    </div>
                                    <div v-if="show_pic" class="form_upload position_relative">
                                        <Icon class="form_icon" size="20" type="ios-close-circle" color="#f00" @click.stop="delImg"/>
                                        <img class="form_img" :src="show_pic" @click="previewImg(show_pic)">
                                    </div>
                                </div>
                            </FormItem>
                        </Col>
                    </template>
                </Row>
            </Form>
        </div>

        <!-- 微信支付设置 -->
        <div class="content section-pay">
            <div class="section-header">
                <Icon type="ios-card-outline" size="20" />
                <span>微信支付设置</span>
                <span class="section-tip">（启用后显示更多配置）</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="150">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="启用微信支付：">
                            <i-switch v-model="formData.is_pay" size="large" true-color="var(--primary-color)" :true-value="1" :false-value="0">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Col>
                </Row>
                <template v-if="formData.is_pay">
                    <Row :gutter="24">
                        <Col span="8">
                            <FormItem label="商户号：">
                                <Input class="w200" type="text" v-model="formData.merchant_no" placeholder="请输入商户号"></Input>
                                <Tooltip max-width="250" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>请填写使用或借用的微信支付商户号，开通微信支付才能获得商户号</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="商户支付密钥：">
                                <Input class="w200" type="text" v-model="formData.pay_secret" placeholder="请输入商户支付密钥"></Input>
                                <Tooltip max-width="250" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>请填写使用或借用的微信支付商户平台的支付密钥</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="证书序列号：">
                                <Input class="w200" type="text" v-model="formData.serial_number" placeholder="请输入证书序列号"></Input>
                                <Tooltip max-width="250" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>请填写使用或借用的微信支付商户平台的证书序列号</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="24">
                        <Col span="8">
                            <FormItem label="支付证书key：">
                                <div class="display_flex">
                                    <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :format="['jpg', 'png', 'pdf', 'pem']"
                                        :max-size="2048"
                                        :on-format-error="handleFormatError"
                                        :on-success="keySuccess"
                                        :on-progress="handleProgress"
                                        :headers="headers"
                                        :action="uploadImg"
                                    >
                                        <Button>{{formData.apiclient_key ? '已成功上传' : '点击上传'}}</Button>
                                    </Upload>
                                    <Tooltip max-width="280" placement="top" theme="light"  transfer>
                                        <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                        <div slot="content">
                                            <p>从商户平台上下载支付证书，解压并取得其中的<span class="theme-color">apiclient-key.pem</span>上传此文件</p>
                                        </div>
                                    </Tooltip>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="支付证书cert：">
                                <div class="display_flex">
                                    <Upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :format="['jpg', 'png', 'pdf', 'pem']"
                                        :max-size="2048"
                                        :on-format-error="handleFormatError"
                                        :on-success="certSuccess"
                                        :on-progress="handleProgress"
                                        :headers="headers"
                                        :action="uploadImg"
                                    >
                                        <Button>{{formData.apiclient_cert ? '已成功上传' : '点击上传'}}</Button>
                                    </Upload>
                                    <Tooltip max-width="280" placement="top"  theme="light" transfer>
                                        <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                        <div slot="content">
                                            <p>从商户平台上下载支付证书，解压并取得其中的<span class="theme-color">apiclient-cert.pem</span>上传此文件</p>
                                        </div>
                                    </Tooltip>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem label="服务器IP：">
                                <Input class="w200" type="text" v-model="formData.ip" placeholder="请输入服务器IP"></Input>
                                <Tooltip max-width="250" placement="top"  theme="light" transfer>
                                    <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                    <div slot="content">
                                        <p>红包接口需要服务器IP，系统将自动获取您的服务器IP，如果获取失败，请手动填写</p>
                                    </div>
                                </Tooltip>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="24">
                        <Col span="8">
                            <FormItem label="商家转账到零钱：">
                                <RadioGroup v-model="formData.transfer_api">
                                    <Radio label="2" style="margin-right: 24px;">新版</Radio>
                                    <Radio label="1">旧版</Radio>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                        <Col span="8" v-if="formData.transfer_api == 2">
                            <FormItem label="转账场景ID：">
                                <Input class="w200" type="text" v-model="formData.transfer_scene_id" placeholder="请输入转账场景ID"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </template>
            </Form>
        </div>

        <!-- 地图与语音设置 -->
        <div class="content section-setting">
            <div class="section-header">
                <Icon type="ios-settings-outline" size="20" />
                <span>地图与语音设置</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="150">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="腾讯地图key：">
                            <Input class="w200" type="text" v-model="formData.tencent_map_key" placeholder="请输入腾讯地图key"></Input>
                            <Tooltip max-width="300" placement="top"  theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                <div slot="content">
                                    <p>配置腾讯地图Key时，请在应用授权IP下增加125.122.16.70。如果使用独立服务器，请把自己的服务器IP配置在授权IP中</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="百度语音key：">
                            <Input class="w200" type="text" v-model="formData.baidu_voice_key" placeholder="请输入百度语音key"></Input>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18"/>
                                <div slot="content">
                                    <p>登陆百度智能云创建应用，使用短文本在线合成API</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="百度语音secret：">
                            <Input class="w200" type="text" v-model="formData.baidu_voice_secret" placeholder="请输入百度语音secret"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 提交按钮 -->
        <div class="footer">
            <Button class="theme-bc theme-default-color btn-submit" @click="submitForm">
                <Icon type="ios-checkmark-circle-outline" size="18" /> 确定保存
            </Button>
        </div>

        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { 
    system_wx_index, 
    system_wx_save,
} from '@/api/index';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { pictureLibrary },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            uploadImg: config.apiUrl + "/api/other/upload",
            headers: { "hlzw-suyuan-token": getCookies("p_c_access_token") },
            formData: { 
                is_wx: "",
                need_follow_wechat:0,
                app_id: "",
                gh_id:"",
                app_secret: "",
                is_pay: "",
                biz:"",
                merchant_no: "",
                pay_secret: "",
                ip: "",
                apiclient_key: "",
                apiclient_cert: "",
                serial_number: "",
                pic: "",
                tencent_map_key: "",
                baidu_voice_key: "",
                baidu_voice_secret: "",
                transfer_api: "",
                transfer_scene_id: 1000,
            },
            show_pic: '',
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_pic = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.pic = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList(){
            system_wx_index().then((res) => {
                if(res.data.admin_id){ 
                    this.formData.is_wx = res.data.is_wx;
                    this.formData.biz = res.data.biz;
                    this.formData.need_follow_wechat = res.data.need_follow_wechat;
                    this.formData.app_id = res.data.app_id;
                    this.formData.gh_id = res.data.gh_id;
                    this.formData.tencent_map_key = res.data.tencent_map_key;
                    this.formData.baidu_voice_key = res.data.baidu_voice_key;
                    this.formData.baidu_voice_secret = res.data.baidu_voice_secret;
                    this.formData.app_secret = res.data.app_secret;
                    this.formData.is_pay = res.data.is_pay;
                    this.formData.merchant_no = res.data.merchant_no;
                    this.formData.pay_secret = res.data.pay_secret;
                    this.formData.ip = res.data.ip;
                    this.formData.transfer_api = res.data.transfer_api + '';
                    this.formData.apiclient_key = res.data.apiclient_key;
                    this.formData.apiclient_cert = res.data.apiclient_cert;
                    this.formData.serial_number = res.data.serial_number;
                    this.formData.pic = res.data.pic;
                    this.formData.transfer_scene_id = res.data.transfer_scene_id ? res.data.transfer_scene_id : 1000;
                    if(res.data.pic){
                        this.show_pic = res.data.show_pic;
                    }
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        submitForm(){
            system_wx_save(this.formData).then( res => {
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        handleProgress(){
            this.$Message.loading({
                content: '上传中...',
                duration: 0
            }) 
        },
        handleFormatError(){                
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        keySuccess(e){
            this.formData.apiclient_key = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        certSuccess(e){
            this.formData.apiclient_cert = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        publicSuccess(e){
            this.formData.public_key_cert = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        platSuccess(e){
            this.formData.plat_key_cert = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);  
        },
        delImg(){
            this.show_pic = ''
            this.formData.pic = ''
        },
        previewImg(item){
            if(item){
                window.open(item);
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.content {
    padding: 20px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
/* 区块标题 */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    font-weight: 600;
    font-size: 16px;
    color: #333;
}
.section-header i {
    margin-right: 8px;
    color: #666;
}
.section-tip {
    margin-left: 8px;
    font-weight: normal;
    font-size: 13px;
    color: #999;
}
/* 公众号区块 */
.section-wechat {
    border-left: 4px solid #07c160;
}
.section-wechat .section-header i {
    color: #07c160;
}
/* 支付区块 */
.section-pay {
    border-left: 4px solid #ff6b00;
}
.section-pay .section-header i {
    color: #ff6b00;
}
/* 设置区块 */
.section-setting {
    border-left: 4px solid #2563eb;
}
.section-setting .section-header i {
    color: #2563eb;
}
/* 页脚 */
.footer {
    padding: 20px 0;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.btn-submit {
    padding: 5px 40px;
    font-size: 15px;
}
.btn-submit i {
    margin-right: 6px;
}
/* 上传样式 */
.form_upload {
    width: 80px;
    height: 80px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px dashed #dcdee2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s;
}
.form_upload:hover {
    border-color: #2563eb;
}
.form_img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
}
.image-div {
    display: flex;
    align-items: center;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #fff;
    border-radius: 50%;
}
/* 通用样式 */
.display_flex {
    display: flex;
    align-items: center;
}
.cursor-p {
    cursor: pointer;
}
.mr12 {
    margin-right: 12px;
}
.ml8 {
    margin-left: 8px;
}
.w200 {
    width: 200px;
}
.theme-color {
    color: #2563eb;
}
.form-p {
    margin-top: 12px;
    font-size: 12px;
    color: #9FA5BB;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-radio-group .ivu-radio-wrapper-checked .ivu-radio-checked .ivu-radio-inner {
    border-color: var(--primary-color);
}
::v-deep .ivu-radio-group .ivu-radio-wrapper-checked .ivu-radio-checked .ivu-radio-inner:after {
    background-color: var(--primary-color);
}
</style>
